
export const ReporteLang = {

    Pagina: {
      es: "Página",
      en: "Page",
    },  
    convenio: {
      es: 'CONVENIO DE APERTURA DE CRÉDITO',
      en: 'CONVENIO DE APERTURA DE CRÉDITO',
    },
    ElPresente: {
        es: 'El presente convenio de apertura de crédito se celebra entre ',
        en: 'El presente convenio de apertura de crédito se celebra entre ',
    },
    enDelante: {
        es: 'en adelante denominado "EL VENDEDOR," y ',
        en: 'en adelante denominado "EL VENDEDOR," y ',
    },
    enDelante1: {
        es: 'en adelante denominado "EL COMPRADOR."',
        en: 'en adelante denominado "EL COMPRADOR."',
    },
    ElObjetivo: {
        es: 'El objetivo de este convenio es regular el suministro continuo de tela, en adelante denominada "los Bienes," así como establecer los derechos y obligaciones de EL COMPRADOR y EL VENDEDOR en relación con los servicios prestados.',
        en: 'El objetivo de este convenio es regular el suministro continuo de tela, en adelante denominada "los Bienes," así como establecer los derechos y obligaciones de EL COMPRADOR y EL VENDEDOR en relación con los servicios prestados.',
    },
    Regulaciones: {
        es: 'Regulaciones',
        en: 'Regulaciones',
    },
    RegulacionesText: {
        es: 'Este convenio regula la venta de productos manufacturados por EL VENDEDOR (en adelante, "los Bienes") adquiridos por EL COMPRADOR, estableciendo con claridad los derechos y obligaciones de ambas partes.',
        en: 'Este convenio regula la venta de productos manufacturados por EL VENDEDOR (en adelante, "los Bienes") adquiridos por EL COMPRADOR, estableciendo con claridad los derechos y obligaciones de ambas partes.',
    },
    Especificaciones: {
        es: 'Especificaciones y Condiciones de los Bienes',
        en: 'Especificaciones y Condiciones de los Bienes',
    },
    EspecificacionesText: {
        es: 'Los elementos, cantidades, calidad y demás condiciones de los Bienes que EL VENDEDOR entregue a EL COMPRADOR serán determinados conforme a los términos del presente convenio y las órdenes de compra emitidas por EL COMPRADOR.',
        en: 'Los elementos, cantidades, calidad y demás condiciones de los Bienes que EL VENDEDOR entregue a EL COMPRADOR serán determinados conforme a los términos del presente convenio y las órdenes de compra emitidas por EL COMPRADOR.',
    },
    Precios: {
        es: 'Precio de los Productos y Servicios',
        en: 'Precio de los Productos y Servicios',
    },
    PreciosText: {
        es: 'EL COMPRADOR y EL VENDEDOR acordarán el precio unitario mediante consulta y mutuo acuerdo teniendo en cuenta las siguientes consideraciones:',
        en: 'EL COMPRADOR y EL VENDEDOR acordarán el precio unitario mediante consulta y mutuo acuerdo teniendo en cuenta las siguientes consideraciones:',
    },
    PreciosA: {
        es: 'Precio con todo incluido: Incluye el costo de las materias',
        en: 'Precio con todo incluido: Incluye el costo de las materias',
    },
    PreciosA_1: {
        es: 'Precio con todo incluido: Incluye el costo de las materias primas y los costos de producción. También podrá incluir los costos de entrega según los términos de exportación (INCOTERMS) acordados entre EL VENDEDOR y EL COMPRADOR en el momento de la compra',
        en: 'Precio con todo incluido: Incluye el costo de las materias primas y los costos de producción. También podrá incluir los costos de entrega según los términos de exportación (INCOTERMS) acordados entre EL VENDEDOR y EL COMPRADOR en el momento de la compra',
    },
    PreciosB_1: {
        es: 'Precio por servicio: Aplica cuando EL COMPRADOR proporciona las materias primas a EL VENDEDOR para la producción de los bienes. También podrá incluir los costos de entrega según los términos de exportación (INCOTERMS) acordados entre EL VENDEDOR y EL COMPRADOR en el momento de la compra.',
        en: 'Precio por servicio: Aplica cuando EL COMPRADOR proporciona las materias primas a EL VENDEDOR para la producción de los bienes. También podrá incluir los costos de entrega según los términos de exportación (INCOTERMS) acordados entre EL VENDEDOR y EL COMPRADOR en el momento de la compra.',
    },

    Desc: {
        es: 'Descripción de los Bienes y/o Servicios',
        en: 'Descripción de los Bienes y/o Servicios',
    },
    DescA: {
        es: 'Origen: Honduras',
        en: 'Origen: Honduras',
    },
    DescB: {
        es: 'Los Bienes serán los descritos en la Orden de Venta proporcionada por EL VENDEDOR',
        en: 'Los Bienes serán los descritos en la Orden de Venta proporcionada por EL VENDEDOR',
    },
    DescC: {
        es: 'EL COMPRADOR se compromete a comprar un mínimo de ',
        en: 'EL COMPRADOR se compromete a comprar un mínimo de ',
    },
    mensuales: {
        es: 'mensuales de bienes por mes a EL VENDEDOR. Dicho volumen podrá incrementarse según la necesidad del COMPRADOR, sujeto a la disponibilidad de los Bienes y previa confirmación de EL VENDEDOR.',
        en: 'mensuales de bienes por mes a EL VENDEDOR. Dicho volumen podrá incrementarse según la necesidad del COMPRADOR, sujeto a la disponibilidad de los Bienes y previa confirmación de EL VENDEDOR.',
    },
    entrega: {
        es: 'Entrega y Plazo de Entrega',
        en: 'Entrega y Plazo de Entrega',
    },
    entregaA: {
        es: 'EL VENDEDOR entregará los Bienes a EL COMPRADOR dentro del plazo acordado a partir de la recepción de la orden de compra.',
        en: 'EL VENDEDOR entregará los Bienes a EL COMPRADOR dentro del plazo acordado a partir de la recepción de la orden de compra.',
    },
    entregaB: {
        es: 'La entrega de los Bienes se realizará conforme a los términos de entrega especificados en cada orden de ',
        en: 'La entrega de los Bienes se realizará conforme a los términos de entrega especificados en cada orden de ',
    },
    entregaB_1: {
        es: 'compra. El riesgo de pérdida o daño de los Bienes pasará a EL COMPRADOR en el momento de la entrega. Ambas partes acuerdan discutir y definir de manera conjunta quién asumirá los costos del seguro de transporte.',
        en: 'compra. El riesgo de pérdida o daño de los Bienes pasará a EL COMPRADOR en el momento de la entrega. Ambas partes acuerdan discutir y definir de manera conjunta quién asumirá los costos del seguro de transporte.',
    },
    entregaC: {
        es: 'Los Bienes deberán ser empacados de manera adecuada para minimizar daños durante su transporte.',
        en: 'Los Bienes deberán ser empacados de manera adecuada para minimizar daños durante su transporte.',
    },    
    defectos: {
        es: 'Defectos y Reclamos',
        en: 'Defectos y Reclamos',
    },
    defectosA: {
        es: 'No se aceptarán reclamos por problemas de calidad después de 30 días con base en la fecha de la emisión de la factura. EL COMPRADOR deberá inspeccionar los Bienes antes de cortarlos o coserlos y notificar a EL VENDEDOR cualquier no conformidad',
        en: 'No se aceptarán reclamos por problemas de calidad después de 30 días con base en la fecha de la emisión de la factura. EL COMPRADOR deberá inspeccionar los Bienes antes de cortarlos o coserlos y notificar a EL VENDEDOR cualquier no conformidad',
    },
    defectosB: {
        es: 'Los bienes deben estar en su condición original de entrega posterior a la apertura del material de empaque y sin alteraciones, caso contrario, se exonera a EL VENDEDOR de toda responsabilidad por tela con defectos o por prendas confeccionadas.',
        en: 'Los bienes deben estar en su condición original de entrega posterior a la apertura del material de empaque y sin alteraciones, caso contrario, se exonera a EL VENDEDOR de toda responsabilidad por tela con defectos o por prendas confeccionadas.',
    },
    defectosC: {
        es: 'Si los Bienes no cumplen con los estándares de inspección o presentan defectos de calidad, EL VENDEDOR deberá reemplazar los bienes defectuosos dentro del plazo de entrega o compensar a EL COMPRADOR por las pérdidas derivadas de los defectos.',
        en: 'Si los Bienes no cumplen con los estándares de inspección o presentan defectos de calidad, EL VENDEDOR deberá reemplazar los bienes defectuosos dentro del plazo de entrega o compensar a EL COMPRADOR por las pérdidas derivadas de los defectos.',
    },
    defectosD: {
        es: 'No se aceptarán reclamos de materia prima o defectos inherentes a la misma cuando los bienes sean manufacturados con materia prima suministrada por EL COMPRADOR, conforme a lo estipulado en la cláusula 11.',
        en: 'No se aceptarán reclamos de materia prima o defectos inherentes a la misma cuando los bienes sean manufacturados con materia prima suministrada por EL COMPRADOR, conforme a lo estipulado en la cláusula 11.',
    },
    condiciones: {
        es: 'Condiciones de pago',
        en: 'Condiciones de pago',
    },
    condicionesA: {
        es: 'EL VENDEDOR otorga a EL COMPRADOR un límite de crédito de ',
        en: 'EL VENDEDOR otorga a EL COMPRADOR un límite de crédito de ',
    },
    condicionesA_1: {
        es: ' y queda establecido que el método de pago será depósito o transferencia después de ',
        en: ' y queda establecido que el método de pago será depósito o transferencia después de ',
    },
    condicionesA_2: {
        es: ' días con base en la fecha de facturación.',
        en: ' días con base en la fecha de facturación.',
    },
    condicionesB: {
        es: 'EL VENDEDOR podrá suspender las entregas o despachos de producto por existir facturas vencidas pendientes de pago o saldos que excedan el límite de crédito (USD 250,000), quedando EL VENDEDOR exonerado de responsabilidad.',
        en: 'EL VENDEDOR podrá suspender las entregas o despachos de producto por existir facturas vencidas pendientes de pago o saldos que excedan el límite de crédito (USD 250,000), quedando EL VENDEDOR exonerado de responsabilidad.',
    },
    condicionesC: {
        es: 'EL COMPRADOR no incurrirá en penalidades ni cargos adicionales por realizar pagos anticipados, dichos pagos serán aceptados y aplicados al saldo pendiente correspondiente, sin que ello implique consecuencias negativas',
        en: 'EL COMPRADOR no incurrirá en penalidades ni cargos adicionales por realizar pagos anticipados, dichos pagos serán aceptados y aplicados al saldo pendiente correspondiente, sin que ello implique consecuencias negativas',
    },

    transferencia : {
        es: 'Transferencia de Derechos, Obligaciones y Garantías',
        en: 'Transferencia de Derechos, Obligaciones y Garantías',
    },
    transferenciaText : {
        es: 'EL COMPRADOR y EL VENDEDOR no podrán ceder, transferir ni utilizar como garantía los derechos y obligaciones derivados de este convenio sin la previa autorización escrita de la otra parte.',
        en: 'EL COMPRADOR y EL VENDEDOR no podrán ceder, transferir ni utilizar como garantía los derechos y obligaciones derivados de este convenio sin la previa autorización escrita de la otra parte.',
    },

    resolucion : {
        es: 'Resolución de Controversias y Jurisdicción',
        en: 'Resolución de Controversias y Jurisdicción',
    },
    resolucionText : {
        es: 'Todas las disputas derivadas de este convenio serán resueltas conforme a la legislación y costumbres comerciales aplicables. ',
        en: 'Todas las disputas derivadas de este convenio serán resueltas conforme a la legislación y costumbres comerciales aplicables. ',
    },
    resolucionText_1 : {
        es: 'En caso de que no sea posible una resolución amigable, la ley aplicable será la legislación hondureña.',
        en: 'En caso de que no sea posible una resolución amigable, la ley aplicable será la legislación hondureña.',
    },

    fuerza : {
        es: 'Fuerza Mayor',
        en: 'Fuerza Mayor',
    },
    fuerzaText : {
        es: 'En caso de que las transacciones entre EL COMPRADOR y EL VENDEDOR se vean afectadas por un evento de fuerza mayor (como incendio, inundación, terremoto, desastre natural, pandemia, huelga, guerra, disturbios civiles, regulaciones gubernamentales, etc.), la parte afectada deberá notificarlo a la otra de manera inmediata. En tales casos, EL COMPRADOR podrá cancelar total o parcialmente sus pedidos sin responsabilidad alguna, salvo por la obligación de pagar los bienes y servicios entregados previo al evento de fuerza mayor.',
        en: 'En caso de que las transacciones entre EL COMPRADOR y EL VENDEDOR se vean afectadas por un evento de fuerza mayor (como incendio, inundación, terremoto, desastre natural, pandemia, huelga, guerra, disturbios civiles, regulaciones gubernamentales, etc.), la parte afectada deberá notificarlo a la otra de manera inmediata. En tales casos, EL COMPRADOR podrá cancelar total o parcialmente sus pedidos sin responsabilidad alguna, salvo por la obligación de pagar los bienes y servicios entregados previo al evento de fuerza mayor.',
    },

    materia : {
        es: 'Materia Prima',
        en: 'Materia Prima',
    },
    materiaText : {
        es: 'Si EL COMPRADOR suministra materia prima (hilo, tela cruda) a EL VENDEDOR para la producción de bienes, los precios se considerarán como comisión y deberán cumplir con lo estipulado en la cláusula 3 de este convenio. La aceptación de la materia prima estará sujeta a las siguientes condiciones:',
        en: 'Si EL COMPRADOR suministra materia prima (hilo, tela cruda) a EL VENDEDOR para la producción de bienes, los precios se considerarán como comisión y deberán cumplir con lo estipulado en la cláusula 3 de este convenio. La aceptación de la materia prima estará sujeta a las siguientes condiciones:',
    },
    materiaA : {
        es: 'La materia prima deberá estar asociada a una orden de compra y ser suficiente para la producción de los bienes solicitados.',
        en: 'La materia prima deberá estar asociada a una orden de compra y ser suficiente para la producción de los bienes solicitados.',
    },
    materiaB : {
        es: 'Cada envío de materia prima para la producción de bienes de EL COMPRADOR no podrá mantenerse almacenada un periodo mayor a tres (3) meses. Cualquier excedente generará un cargo de ',
        en: 'Cada envío de materia prima para la producción de bienes de EL COMPRADOR no podrá mantenerse almacenada un periodo mayor a tres (3) meses. Cualquier excedente generará un cargo de ',
    },
    materiaB_1 : {
        es: 'por metro cúbico (m³ o CBM) de espacio utilizado, el cual será facturado por EL VENDEDOR y pagadero de forma inmediata, sin otorgamiento de crédito.',
        en: 'por metro cúbico (m³ o CBM) de espacio utilizado, el cual será facturado por EL VENDEDOR y pagadero de forma inmediata, sin otorgamiento de crédito.',
    },
    materiaC : {
        es: 'En caso de mora en el pago (según la cláusula 7), la materia prima almacenada en las bodegas de EL VENDEDOR podrá ser consideradas como garantía del pago pendiente.',
        en: 'En caso de mora en el pago (según la cláusula 7), la materia prima almacenada en las bodegas de EL VENDEDOR podrá ser consideradas como garantía del pago pendiente.',
    },
    materiaD : {
        es: 'La devolución de cualquier cantidad de materia prima a EL COMPRADOR generará un costo de carga y despacho los cuales se cobrarán de acuerdo con los precios vigentes de los suministros y gastos administrativos que conlleve el retorno.',
        en: 'La devolución de cualquier cantidad de materia prima a EL COMPRADOR generará un costo de carga y despacho los cuales se cobrarán de acuerdo con los precios vigentes de los suministros y gastos administrativos que conlleve el retorno.',
    },
    materiaE : {
        es: 'EL COMPRADOR será responsable del seguro de la materia prima almacenada en las bodegas de EL VENDEDOR.',
        en: 'EL COMPRADOR será responsable del seguro de la materia prima almacenada en las bodegas de EL VENDEDOR.',
    },
    materiaF : {
        es: 'En caso de que cualquiera de las partes decida dar por terminada la relación comercial, ya sea por vencimiento del presente convenio o mediante notificación escrita, EL COMPRADOR dispondrá de un plazo máximo de noventa (90) días calendario, contados a partir de la fecha de terminación, para retirar la materia prima almacenada en las bodegas de EL VENDEDOR. Transcurrido dicho plazo sin que EL COMPRADOR haya retirado la totalidad de la materia prima, se considerará que esta ha sido abandonada, facultando a EL VENDEDOR para disponer ',
        en: 'En caso de que cualquiera de las partes decida dar por terminada la relación comercial, ya sea por vencimiento del presente convenio o mediante notificación escrita, EL COMPRADOR dispondrá de un plazo máximo de noventa (90) días calendario, contados a partir de la fecha de terminación, para retirar la materia prima almacenada en las bodegas de EL VENDEDOR. Transcurrido dicho plazo sin que EL COMPRADOR haya retirado la totalidad de la materia prima, se considerará que esta ha sido abandonada, facultando a EL VENDEDOR para disponer ',
    },
    materiaF1 : {
        es: 'de ella de manera libre y a su entera discreción, ya sea mediante su venta, destrucción, reciclaje o cualquier otro uso que estime conveniente, sin que ello genere responsabilidad alguna para EL VENDEDOR ni derecho a reclamación por parte de EL COMPRADOR. Asimismo, EL COMPRADOR será responsable de cubrir cualquier costo adicional que se genere por el almacenamiento de la materia prima durante el plazo de noventa (90) días, así como cualquier gasto relacionado con su disposición posterior en caso de abandono.',
        en: 'de ella de manera libre y a su entera discreción, ya sea mediante su venta, destrucción, reciclaje o cualquier otro uso que estime conveniente, sin que ello genere responsabilidad alguna para EL VENDEDOR ni derecho a reclamación por parte de EL COMPRADOR. Asimismo, EL COMPRADOR será responsable de cubrir cualquier costo adicional que se genere por el almacenamiento de la materia prima durante el plazo de noventa (90) días, así como cualquier gasto relacionado con su disposición posterior en caso de abandono.',
    },

    vigencia : {
        es: 'Vigencia',
        en: 'Vigencia',
    },
    vigenciaText : {
        es: 'Este convenio tendrá una duración de',
        en: 'Este convenio tendrá una duración de',
    },
    vigenciaText1 : {
        es: 'meses a partir de la fecha de entrada en vigor, salvo que ambas partes acuerden su terminación anticipada por escrito.',
        en: 'meses a partir de la fecha de entrada en vigor, salvo que ambas partes acuerden su terminación anticipada por escrito.',
    },

    disposiciones : {
        es: 'Disposiciones Generales',
        en: 'Disposiciones Generales',
    },
    disposicionesA : {
        es: 'Cualquier aspecto no previsto en este convenio será resuelto mediante mutuo acuerdo entre EL COMPRADOR y EL VENDEDOR o conforme a las prácticas comerciales generales.',
        en: 'Cualquier aspecto no previsto en este convenio será resuelto mediante mutuo acuerdo entre EL COMPRADOR y EL VENDEDOR o conforme a las prácticas comerciales generales.',
    },
    disposicionesB : {
        es: 'En caso de conflicto entre este convenio y cualquier otro acuerdo previo o posterior, prevalecerá el presente.',
        en: 'En caso de conflicto entre este convenio y cualquier otro acuerdo previo o posterior, prevalecerá el presente.',
    },
    disposicionesC : {
        es: 'El presente convenio será firmado por ambas partes, quienes declaran haber comprendido íntegramente su contenido. No hubo engaño, error ni desacuerdo durante su celebración. Se elaboran dos (2) copias, conservando cada parte un ejemplar.',
        en: 'El presente convenio será firmado por ambas partes, quienes declaran haber comprendido íntegramente su contenido. No hubo engaño, error ni desacuerdo durante su celebración. Se elaboran dos (2) copias, conservando cada parte un ejemplar.',
    },

    fecha : {
        es: 'Fecha',
        en: 'Date',
    },

    comprador : {
        es: 'EL COMPRADOR',
        en: 'EL COMPRADOR',
    },
    direccion : {
        es: 'Dirección',
        en: 'Dirección',
    },

    vendedor : {
        es: 'EL VENDEDOR',
        en: 'EL VENDEDOR',
    },

    




};